import { EllipsisOutlined } from "@ant-design/icons"; // Added EllipsisOutlined
import {
  Avatar,
  Button,
  Dropdown,
  Flex,
  Tag, // Added Avatar
  Tooltip,
  Typography,
} from "antd";
import { createEditor, EditorState } from "lexical";
import React, { useEffect, useState } from "react";
import { PiDotsThreeOutlineBold } from "react-icons/pi";

import { useToken } from "../../hooks/useToken"; // Ensure path is correct
import { TInterest } from "../../models/interests.model";
import { Editor } from "../editor/Editor"; // Ensure path is correct
import { PImage } from "../PImage";

const { Title, Paragraph, Text } = Typography;
// const { useToken } = theme; // useToken comes from custom hook now

interface CardProps {
  // Changed name to avoid conflict
  modelStyle?: "OLD" | "NEW";
  model: {
    featuredImage?: boolean;
    gallery?: boolean;
    video?: boolean;
    audio?: boolean;
    title?: boolean;
    description?: boolean;
    cta?: boolean;
    interests?: boolean;
  };

  title?: string;
  description?: string;
  interests?: TInterest[];

  ctaTitle?: string;
  ctaAction?: () => void;

  featuredImage?: string;
  featuredGallery?: string[];
  featuredVideo?: string;
  featuredAudio?: string;

  cardTitle?: string;
  cardIcon?: React.ReactNode | string;

  onClick?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onShare?: () => void;
}

export function Card({
  model,
  modelStyle,
  title,
  description,
  interests,
  cardIcon,
  cardTitle,
  featuredAudio,
  featuredGallery,
  featuredImage,
  featuredVideo,
  ctaAction,
  ctaTitle,
  onClick,
  onDelete,
  onEdit,
  onShare,
}: CardProps) {
  const { token } = useToken();
  // const iconImageURL = useImageURL({
  //   mediaId: typeof cardIcon == "string" ? cardIcon : "",
  // });

  const handleShareClick = (info: any) => {
    info.domEvent.stopPropagation();
    onShare?.();
  };

  const handleEditClick = (info: any) => {
    info.domEvent.stopPropagation();
    onEdit?.();
  };

  const handleDeleteClick = (info: any) => {
    info.domEvent.stopPropagation();
    onDelete?.();
  };

  const handleFavoriteClick = (info: any) => {
    info.domEvent.stopPropagation();
    console.log("Favorite clicked");
  };

  return (
    <>
      <Flex
        vertical
        style={{
          position: "relative",
          backdropFilter: "blur(20px)",
          backgroundColor: token.colorBgBase,
          borderRadius: token.borderRadiusLG,
          border: `${token.lineHeight}px ${token.lineType} ${token.colorBorder}`,
        }}
      >
        <Flex style={{ position: "relative" }}>
          {model.featuredImage && featuredImage && (
            <>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  borderRadius:
                    modelStyle == "NEW"
                      ? `${token.borderRadiusLG}px`
                      : `${token.borderRadiusLG}px ${token.borderRadiusLG}px 0 0`,
                  background:
                    modelStyle == "OLD"
                      ? "linear-gradient(154.97deg, rgba(52, 58, 64, 0.4) 31.25%, rgba(33, 37, 40, 0.4) 98.25%), linear-gradient(0deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.5) 100%),linear-gradient(0deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.5) 100%)"
                      : "linear-gradient(0deg, rgba(9, 9, 11, 0.4), rgba(9, 9, 11, 0.4)), linear-gradient(0deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.5) 100%),linear-gradient(0deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.5) 100%)",
                }}
              />
              {(featuredImage ||
                (featuredGallery && featuredGallery.length > 0)) && (
                <PImage
                  mediaId={featuredImage || featuredGallery?.[0]}
                  style={{
                    width: "100%",
                    height: "100%",
                    maxHeight: "200px",
                    objectFit: "cover",
                    borderRadius:
                      modelStyle == "NEW"
                        ? `${token.borderRadiusLG}px`
                        : `${token.borderRadiusLG}px ${token.borderRadiusLG}px 0 0`,
                  }}
                />
              )}
            </>
          )}

          {model.gallery && featuredGallery && featuredGallery.length > 0 && (
            <Flex
              style={{
                width: "100%",
                height: "100%",
                padding: token.paddingSM,
                marginTop: token.marginXXL,
              }}
            >
              {featuredGallery.length == 1 && (
                <CardGalleryItem mediaId={featuredGallery[0]} />
              )}
              {featuredGallery.length == 2 && (
                <Flex gap="8px" style={{ width: "100%" }}>
                  <CardGalleryItem mediaId={featuredGallery[0]} />
                  <CardGalleryItem mediaId={featuredGallery[1]} />
                </Flex>
              )}
              {featuredGallery.length >= 3 && (
                <Flex gap="8px" style={{ width: "100%", height: "200px" }}>
                  <Flex vertical gap="8px" style={{ width: "50%" }}>
                    <CardGalleryItem mediaId={featuredGallery[0]} />
                  </Flex>
                  <Flex vertical gap="8px" style={{ width: "50%" }}>
                    <CardGalleryItem mediaId={featuredGallery[1]} />
                    <CardGalleryItem mediaId={featuredGallery[2]} />
                  </Flex>
                </Flex>
              )}
            </Flex>
          )}
        </Flex>

        <Flex
          align="center"
          justify="space-between"
          style={{
            padding: token.paddingSM,
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 2,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {(cardTitle || cardIcon) && (
            <Flex
              align="center"
              style={{
                flexShrink: 1,
                overflow: "hidden",
                marginRight: token.marginXS,
              }}
            >
              {cardIcon && (
                <>
                  {typeof cardIcon !== "string" && (
                    <Avatar
                      size={26}
                      src={cardIcon || undefined}
                      icon={<EllipsisOutlined />}
                      style={{ marginRight: "5px", flexShrink: 0 }}
                    />
                  )}
                  {typeof cardIcon === "string" && (
                    <img
                      src={cardIcon}
                      style={{
                        width: "25px",
                        height: "25px",
                        marginRight: "5px",
                        borderRadius: token.borderRadiusSM,
                      }}
                    />
                  )}
                </>
              )}
              {cardTitle && (
                <Text
                  style={{
                    fontSize: token.fontSizeSM,
                    color: token.colorWhite,
                  }}
                  ellipsis={{ tooltip: cardTitle }}
                >
                  {cardTitle}
                </Text>
              )}
            </Flex>
          )}

          {(onShare || onEdit || onDelete) && (
            <Dropdown
              trigger={["click"]}
              menu={{
                items: [
                  ...(onShare
                    ? [
                        {
                          label: "Share",
                          key: "share",
                          onClick: handleShareClick,
                        },
                      ]
                    : []),
                  ...(onShare && (onEdit || onDelete)
                    ? [{ type: "divider" as const }]
                    : []),

                  ...(onEdit
                    ? [{ label: "Edit", key: "edit", onClick: handleEditClick }]
                    : []),
                  ...(onEdit && onDelete ? [{ type: "divider" as const }] : []),
                  ...(onDelete
                    ? [
                        {
                          label: "Delete",
                          key: "delete",
                          danger: true,
                          onClick: handleDeleteClick,
                        },
                      ]
                    : []),
                ].filter((item) => item !== null),
              }}
            >
              <Button
                size="small"
                type="text"
                onClick={(e) => {
                  e.stopPropagation();
                }}
                style={{ color: token.colorTextDescription }}
                aria-label="Actions"
              >
                <PiDotsThreeOutlineBold size="16px" />
              </Button>
            </Dropdown>
          )}
        </Flex>

        <Flex
          vertical
          style={{
            padding: token.paddingSM,
            minHeight: modelStyle == "NEW" ? "80px" : "auto",
            cursor: onClick ? "pointer" : "default",
            position: "relative",
            marginTop:
              model.featuredImage && modelStyle === "OLD" ? 0 : token.marginSM,
          }}
          onClick={() => {
            onClick?.();
          }}
        >
          {modelStyle == "OLD" && model.title && title && (
            <Text
              style={{
                fontSize: token.fontSizeHeading4,
                lineHeight: token.lineHeightHeading4,
                color: token.colorText,
                fontWeight: token.fontWeightStrong,
                marginBottom: token.marginSM,
                marginTop:
                  !model.featuredImage && !model.gallery ? token.marginXL : 0,
              }}
            >
              {title}
            </Text>
          )}
          {modelStyle == "NEW" && model.title && title && (
            <Flex
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                padding: token.paddingSM,
              }}
            >
              <Text
                style={{
                  fontSize: token.fontSizeHeading4,
                  lineHeight: token.lineHeightHeading4,
                  color: token.colorText,
                  fontWeight: token.fontWeightStrong,
                }}
              >
                {title}
              </Text>
            </Flex>
          )}

          {modelStyle == "OLD" && (
            <div
              style={{
                marginBottom: token.marginSM,
              }}
            >
              {model.description && description && (
                <EditorReadonly
                  text={description}
                  extraStyle={{
                    color: token.colorTextSecondary,
                    fontSize: token.fontSizeLG,
                    lineHeight: token.lineHeightLG,
                    marginBottom: token.marginSM,
                  }}
                />
              )}
              {model.interests && interests && interests.length > 0 && (
                <Flex align="center" style={{ marginTop: token.marginSM }}>
                  {interests.map((interest) => (
                    <Tooltip key={interest.id} title={interest.name}>
                      <Tag
                        color={interest.color}
                        title={interest.name}
                        style={{
                          borderRadius: "50%",
                          width: "16px",
                          height: "16px",
                        }}
                      />
                    </Tooltip>
                  ))}
                </Flex>
              )}
            </div>
          )}
          {model.cta && (ctaTitle || ctaAction) && (
            <Button
              type="primary"
              style={{
                marginTop:
                  interests && interests.length > 0 ? token.marginXL : "",
              }}
              onClick={() => {
                ctaAction?.();
              }}
            >
              {ctaTitle || "Call to action"}
            </Button>
          )}
        </Flex>
      </Flex>
    </>
  );
}

function CardGalleryItem({ mediaId }: { mediaId: string }) {
  const { token } = useToken();

  return (
    <PImage
      mediaId={mediaId}
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: token.borderRadiusLG,
      }}
      wrapperStyle={{
        width: "100%",
        height: "100%",
        borderRadius: token.borderRadiusLG,
        overflow: "hidden",
      }}
      // preview={false}
    />
  );
}

function EditorReadonly({
  text,
  extraStyle,
}: {
  text: string;
  extraStyle: React.CSSProperties;
}) {
  const [state, setState] = useState<EditorState>();

  useEffect(() => {
    if (!text) return;

    const editor = createEditor({});
    let editorStateJSONString: string | undefined;

    try {
      JSON.parse(text);
      editorStateJSONString = text;
    } catch (error) {
      console.warn(
        "EditorReadonly: Input text is not valid JSON, treating as plain text."
      );
      editorStateJSONString = JSON.stringify({
        root: {
          children: [
            {
              type: "paragraph",
              version: 1,
              children: [
                {
                  detail: 0,
                  format: 0,
                  mode: "normal",
                  style: "",
                  text: text,
                  type: "text",
                  version: 1,
                },
              ],
              direction: null,
              format: "",
              indent: 0,
            },
          ],
          direction: null,
          format: "",
          indent: 0,
          type: "root",
          version: 1,
        },
      });
    }

    try {
      if (editorStateJSONString) {
        setState(editor.parseEditorState(editorStateJSONString));
      }
    } catch (parseError) {
      console.error(
        "EditorReadonly: Error parsing final editor state string:",
        parseError
      );
      setState(
        editor.parseEditorState(
          JSON.stringify({
            root: {
              children: [{ type: "paragraph", version: 1, children: [] }],
              direction: null,
              format: "",
              indent: 0,
              type: "root",
              version: 1,
            },
          })
        )
      );
    }
  }, [text]);

  return (
    <>
      {state && (
        <Editor
          onState={() => {}}
          state={state}
          extraStyle={extraStyle}
          editable={false}
          maxLength={250}
        />
      )}
    </>
  );
}
